import ModalEmploymentRecordEdit from './ModalEmploymentRecordEdit';

export default ModalEmploymentRecordEdit;
